// @owners { team: patient-health }
import { range } from 'lodash';

export const RECURRENCE_SELECTION_KEYS = {
  daily: 'daily',
  day_interval: 'day_interval',
  dow: 'dow',
};

export const RECURRENCE_SELECTIONS = {
  [RECURRENCE_SELECTION_KEYS.daily]: 'Daily',
  [RECURRENCE_SELECTION_KEYS.day_interval]: 'Days interval',
  [RECURRENCE_SELECTION_KEYS.dow]: 'Specific days',
};

export const DAYS = ['Mon', 'Tues', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export const DAYS_INTERVAL = range(2, 31).map((num) => ({
  display: num.toString(),
  value: num,
}));

// for ReminderBuilderInputTime.tsx
export const HOURS = range(1, 13).map((value) => ({
  display: value.toString(),
  value,
}));

export const MINUTES = [
  {
    display: '00',
    value: 0,
  },
  {
    display: '15',
    value: 15,
  },
  {
    display: '30',
    value: 30,
  },
  {
    display: '45',
    value: 45,
  },
];

export const PERIODS = [
  {
    display: 'AM',
    value: 0,
  },
  {
    display: 'PM',
    value: 1,
  },
];
